/* Smooth native FAQ disclosures, including interrupted/reversed transitions. */
(() => {
  if (window.felkisSmoothFaqInstalled) return;
  window.felkisSmoothFaqInstalled = true;
  const states = new WeakMap();
  document.addEventListener('click', event => {
    const summary = event.target.closest?.('summary');
    const details = summary?.parentElement;
    if (!details?.matches('.fp2-faq details, .fk-guide-faq details')) return;
    if (event.target.closest('a,button,input,select,textarea')) return;
    event.preventDefault();
    event.stopPropagation();
    const previous = states.get(details);
    const expanded = !(previous ? previous.expanded : details.open);
    const start = details.getBoundingClientRect().height;
    previous?.animation?.cancel();
    const state = { expanded, animation: null };
    states.set(details, state);
    const finish = () => {
      if (states.get(details) !== state) return;
      details.open = expanded;
      summary.setAttribute('aria-expanded', String(expanded));
      details.style.removeProperty('overflow');
      details.removeAttribute('data-fk-faq-animating');
      states.delete(details);
    };
    summary.setAttribute('aria-expanded', String(expanded));
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
      finish();
      return;
    }
    details.open = true;
    details.setAttribute('data-fk-faq-animating', '');
    const css = getComputedStyle(details);
    const closed = summary.getBoundingClientRect().height +
      parseFloat(css.borderTopWidth) + parseFloat(css.borderBottomWidth) +
      parseFloat(css.paddingTop) + parseFloat(css.paddingBottom);
    const end = expanded ? details.getBoundingClientRect().height : closed;
    details.style.overflow = 'hidden';
    state.animation = details.animate([{ height: `${start}px` }, { height: `${end}px` }], {
      duration: 360, easing: 'cubic-bezier(.22,1,.36,1)'
    });
    state.animation.onfinish = finish;
  }, true);
})();
